import { Card, CardContent, Stack, Typography } from "@mui/material";
import type { ReactNode } from "react";
export function StatCard({
  label,
  value,
  caption,
  icon,
}: {
  label: string;
  value: ReactNode;
  caption?: string;
  icon?: ReactNode;
}) {
  return (
    <Card>
      <CardContent>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <div>
            <Typography color="text.secondary" variant="body2">
              {label}
            </Typography>
            <Typography variant="h4" sx={{ mt: 0.6 }}>
              {value}
            </Typography>
            {caption && (
              <Typography color="text.secondary" variant="caption">
                {caption}
              </Typography>
            )}
          </div>
          {icon}
        </Stack>
      </CardContent>
    </Card>
  );
}
